import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 空运附加费列表
export function querySurchargeAirs(data) {
  return request({
    url: URL.price.querySurchargeAirs,
    method: 'post',
    data
  })
}

// 空运附加费-保存
export function saveSurchargeAir(data) {
  return request({
    url: URL.price.saveSurchargeAir,
    method: 'post',
    data
  })
}
// 空运附加费-删除
export function deleteSurchargeAirs(data) {
  return request({
    url: URL.price.deleteSurchargeAirs,
    method: 'post',
    data
  })
}
// 空运附加费-审核
export function approveSurchargeAirs(data) {
  return request({
    url: URL.price.approveSurchargeAirs,
    method: 'post',
    data
  })
}
